/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';

import type { JSX } from '@ovhcloud/ods-stencil/components/tabs/custom-elements';

import { defineCustomElement as defineOsdsTabBar } from '@ovhcloud/ods-stencil/components/tabs/custom-elements/osds-tab-bar.js';
import { defineCustomElement as defineOsdsTabBarItem } from '@ovhcloud/ods-stencil/components/tabs/custom-elements/osds-tab-bar-item.js';
import { defineCustomElement as defineOsdsTabPanel } from '@ovhcloud/ods-stencil/components/tabs/custom-elements/osds-tab-panel.js';
import { defineCustomElement as defineOsdsTabs } from '@ovhcloud/ods-stencil/components/tabs/custom-elements/osds-tabs.js';

export const OsdsTabBar = /*@__PURE__*/createReactComponent<JSX.OsdsTabBar, HTMLOsdsTabBarElement>('osds-tab-bar', undefined, undefined, defineOsdsTabBar);
export const OsdsTabBarItem = /*@__PURE__*/createReactComponent<JSX.OsdsTabBarItem, HTMLOsdsTabBarItemElement>('osds-tab-bar-item', undefined, undefined, defineOsdsTabBarItem);
export const OsdsTabPanel = /*@__PURE__*/createReactComponent<JSX.OsdsTabPanel, HTMLOsdsTabPanelElement>('osds-tab-panel', undefined, undefined, defineOsdsTabPanel);
export const OsdsTabs = /*@__PURE__*/createReactComponent<JSX.OsdsTabs, HTMLOsdsTabsElement>('osds-tabs', undefined, undefined, defineOsdsTabs);
